import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import PageMenu from "../../blocks/PageMenu/PageMenu";
import ManagementList from "../../blocks/ManagementItemBlock/ManagementList";
import useCheckTypes from "../../../hooks/useCheckRecordStatusAndTypes";
import useGetAllAdministrationRecord from "../../../services/recordSheets/useGetAllAdministrationRecord";
import useGetAllEconomicRecord from "../../../services/recordSheets/useGetAllEconomicRecord";
import IconArrowGray from "../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import LoaderMin from "components/blocks/Loader/LoaderMin";

const RecordDetailManagement: React.FC = () => {
  const { managementType: type, id: paramsId } = useParams<{ managementType: string; id: string }>();
  const arrParamsId = (paramsId || "").split("_");
  const recordType = arrParamsId[0];
  const recordId = arrParamsId[1];
  const [managementSheets, setManagementSheets] = useState<any[] | null>(null);
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);
  const tokenResponse = useDecode("token");
  const userId = tokenResponse && tokenResponse.extension_id;
  const { checkRecordType } = useCheckTypes();

  const { getAllAdministrationRecord, loadingGetAllAdministrationRecord } = useGetAllAdministrationRecord();
  const { getAllEconomicRecord, loadingGetAllEconomicRecord } = useGetAllEconomicRecord();

  const checkManagementType = (t: string) => {
    switch (t) {
      case "economico": return "Económico";
      case "administracion": return "Administración";
      default: return "Gestión";
    }
  };

  useEffect(() => {
    if (type === "economico") {
      getAllEconomicRecord(userId, recordId, setManagementSheets);
    } else if (type === "administracion") {
      getAllAdministrationRecord(userId, recordId, setManagementSheets);
    }
    setBreadcrumbs(["Historial", checkRecordType(parseInt(recordType)), checkManagementType(type)]);
  }, []);

  const isLoading = loadingGetAllAdministrationRecord || loadingGetAllEconomicRecord;

  return (
    <>
      <PageMenu title={checkManagementType(type)} type="bottom-box-info" breadcrumbs={breadcrumbs}>
        <div className="btns-header-container">
          <Link to={`/historial/${recordType}_${recordId}`}>
            <img src={IconArrowGray} alt="icon arrow right" />
          </Link>
        </div>
      </PageMenu>
      <section>
        <div className="container">
          {isLoading && managementSheets === null ? (
            <LoaderMin />
          ) : (
            <ManagementList
              arrData={managementSheets ?? []}
              typeComponent={checkManagementType(type)}
              iconName={type === "economico" ? "euro" : "calendar"}
              variant={type === "economico" ? "amber" : "blue"}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default RecordDetailManagement;
